
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalUserData from '@/components/templates/ModalUserData.vue'
import { AvatarCode } from '@/const/AvatarCode'
import { UsersApi } from '@/api/methods/UsersApi'
import { UsersApi as ManageUsersApi } from '@/api/methods/manage/UsersApi'
import UpdateCookieUtils, { UpdateCookieValue } from '@/utils/UpdateCookieUtils'

/**
 * ユーザ情報編集モーダル
 */
@Component({
  components: {
    ModalUserData,
  },
})
export default class ModalEditUserData extends Vue {
  /** ユーザ情報編集モーダルのフォーマット */
  @Ref()
  modalUserData!: ModalUserData

  /** 権限 */
  @Prop()
  private role!: string

  /** ユーザID */
  private userId!: number

  /** アイコン画像のリスト */
  private avatarList: AvatarCode.AvatarMaster[] = AvatarCode.LIST

  /**
   * 確認ボタン押下時の処理
   *
   * @param nickname ニックネーム
   * @param iconCode アイコンコード
   */
  private async submitEditedData(nickname: string, iconCode: string): Promise<void> {
    this.$loading.start()

    // 入力チェック
    if (!nickname) {
      alert('ニックネームを入力してください')
      this.$loading.complete()
      return
    }

    // ユーザ情報更新
    await ManageUsersApi.updateUser(nickname, iconCode)

    // クッキーの更新情報設定
    const updateCookieItems: UpdateCookieValue = {
      nickname: nickname,
      avatarIconCode: iconCode,
    }

    // クッキー情報更新
    if (this.role) {
      await UpdateCookieUtils.updateCookies(this.role, updateCookieItems)
    }

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()

    // Cookie再読み込みのため、自画面に遷移(VueRouterの警告回避のため、hrefを使用して強制的に遷移)
    window.location.href = this.$route.fullPath
  }

  /**
   * モーダルを開く
   *
   * @param userId ユーザID
   */
  public async show(userId: number): Promise<void> {
    // ユーザIDを設定
    this.userId = userId

    // 最新のユーザ情報を取得する
    const userInformation = await UsersApi.getUser(userId)

    // モーダルを開く
    this.modalUserData.show(userInformation.nickname, userInformation.avatarIconCode)
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalUserData.hide()
  }
}
